import React, { useContext, useEffect, useState } from "react"
import { Col, Form, Row, Tab, Tabs, Table, ButtonGroup } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import {
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
  numberFormatInt,
  getType,
  selectDropdownStyle,
} from "../../../Helpers/Utils/Common"
import cleanLogo from "../../../Assets/Images/Login/transparent_bg.png"

import DeleteModal from "../../../Components/Modals/DeleteModal"
import Navbar from "../../../Components/Navbar/Navbar"
import TableTemp from "../../../Components/TableTemplate/Table"
import POModal from "./Components/POModal"
import PoPaymentModal from "./Components/PoPaymentModal"
import Select from "react-select"
import toast from "react-hot-toast"
import {
  changeStatusPurchaseOrder,
  changeMultipleStatus,
  deletePurchaseOrder,
  searchPurchaseOrder,
  getPoItems,
} from "../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import { getAllSuppliers } from "../../../Helpers/apiCalls/suppliersApi"
import EmailPurchaseOrder from "./Components/EmailPurchaseOrder"
import "./PurchaseOrders.css"
import Moment from "moment"
import DatePicker from "react-datepicker"
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import AdjustmentTableWithDynamicPagination from "../../../Components/TableTemplate/AdjustmentTableWithDynamicPagination"
import Footer from "../../../Components/Footer/Footer"
import { Context } from "../../../Helpers/Utils/Context"
import moment from "moment"

export default function PurchaseOrders() {
  let navigate = useNavigate()
  const [inactive, setInactive] = useState(true)
  const userType = getType()
  const [POtype, setPOType] = useState("")
  const [isClicked, setIsClicked] = useState(false)
  const accountType = getType()
  const today = new Date()
  const aweekago = new Date()
  aweekago.setDate(aweekago.getDate() - 7)
  const { setDateFrom, setDateTo, dateFilter, currentTab, setCurrentTab } =
    useContext(Context)

  /* delete modal handler */
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => setShowDeleteModal(false)

  /* add payment modal handler */
  const [showAddPaymentModal, setShowAddPaymentModal] = useState(false)
  const handleShowAddPaymentModal = () => setShowAddPaymentModal(true)
  const handleCloseAddPaymentModal = () => setShowAddPaymentModal(false)

  const [showPrintModal, setShowPrintModal] = useState(false)
  const handleShowPrintModal = () => setShowPrintModal(true)
  const handleClosePrintModal = () => setShowPrintModal(false)

  const [poID, setPoID] = useState({ id: "", supplier: "" })
  const [bal, setBal] = useState("")
  const [checkedItems, setCheckedItems] = useState([])
  const [checkedItemsDetails, setCheckedItemsDetails] = useState({})
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const [filterConfig, setFilterConfig] = useState({
    tab:
      currentTab && currentTab !== ""
        ? currentTab
        : accountType === "admin"
        ? "for_approval"
        : accountType === "warehouse_manager" ||
          accountType === "warehouse_assistant"
        ? "sent"
        : "pending",
    status:
      currentTab && currentTab !== ""
        ? currentTab
        : accountType === "admin"
        ? "for_approval"
        : accountType === "warehouse_manager" ||
          accountType === "warehouse_assistant"
        ? "sent"
        : "pending",
    // status:
    //   accountType === "admin"
    //     ? "for_approval"
    //     : accountType === "warehouse_manager" ||
    //       accountType === "warehouse_assistant"
    //     ? "sent"
    //     : "pending",
    order_status: currentTab || "",
    supplier_id: "",
    type: "",
    page: "1",
    purchase_date_from: dateFilter.date_from ? dateFilter.date_from : "",
    purchase_date_to: dateFilter.date_to ? dateFilter.date_to : "",
  })

  /* approve modal handler */
  const [showApproveModal, setShowApproveModal] = useState(false)
  const handleShowApproveModal = () => {
    checkedItems.length !== 0
      ? setShowApproveModal(true)
      : toast.error("Please select order/s to approve", {
          style: toastStyle(),
        })
  }
  const handleCloseApproveModal = () => setShowApproveModal(false)

  /* disapprove modal handler */
  const [showDisapproveModal, setShowDisapproveModal] = useState(false)
  const handleShowDisapproveModal = () => {
    checkedItems.length !== 0
      ? setShowDisapproveModal(true)
      : toast.error("Please select order/s to disapprove", {
          style: toastStyle(),
        })
  }
  const handleCloseDisapproveModal = () => setShowDisapproveModal(false)
  const [purchasesManager, setPurchasesManager] = useState([])
  const [printItems, setPrintItems] = useState([])

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  async function searchPO(filterConfig) {
    setShowLoader(true)
    var allData = []
    setPurchasesManager([])
    setTotalItems(0)

    const response = await searchPurchaseOrder(filterConfig)
    if (response.data) {
      response.data.data.map((PO) => {
        var info = PO
        info = PO
        info.no = PO.id
        info.id = PO.id
        info.type = ""
        info.purchase_date = Moment(PO.purchase_date).format("MMM DD, YYYY")
        info.completed_on = PO.completed_on
          ? Moment(PO.completed_on).format("MMM DD, YYYY")
          : PO.status.split("_").join(" ")
        info.trade_name = PO.supplier_trade_name
          ? PO.supplier_trade_name
          : PO.vendor_trade_name
        info.grand_total = numberFormat(PO.grand_total)
        info.balance = PO.balance ? numberFormat(PO.balance) : ""
        info.order_status = PO.order_status
        info.can_be_paid = PO.can_be_paid
        info.po_status = PO.status
        info.payment_status = PO.payment_status
        info.added_by_name = PO.added_by_name
        info.printed_by_name = PO.printed_by_name
        info.supplier_id = PO.supplier_id
        info.added_by_name = PO.added_by_name
        info.pay_ref_no = !PO.payments
          ? ""
          : PO.payments
              .map((data) => {
                return data.doc_no
              })
              .join(", ")
        info.invoice = PO.invoice_no?.map((invoice) => {
          return invoice.invoice_no ? invoice.invoice_no : ""
        })
        info.invoice_id = PO.invoice_no?.map((invoice) => {
          return invoice.id ? invoice.id : ""
        })
        allData.push(info)
        return info
      })
      setTotalItems(response.data.size)
    }

    setPurchasesManager(
      allData
        .sort(
          (a, b) =>
            new Date(...a.purchase_date?.split("/").reverse()) -
            new Date(...b.purchase_date?.split("/").reverse())
        )
        .reverse()
    )
    setShowLoader(false)
  }

  async function mergePoItems() {
    setPrintItems([])
    const response = await getPoItems(checkedItems)
    if (response.data) {
      setPrintItems(response.data.data)
      setTimeout(() => {
        handlePrintPI()
      }, 1000)
    }
  }

  const handleTabSelect = (tabKey) => {
    setCurrentPage(1)
    setCurrentTab(tabKey)
    setCheckedItems([])
    if (tabKey === "complete" || tabKey === "incomplete") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: tabKey,
          status: "",
          order_status: tabKey,
          supplier_id: "",
          vendor_id: "",
          purchase_date_from: dateFilter.date_from ? dateFilter.date_from : "",
          purchase_date_to: dateFilter.date_to ? dateFilter.date_to : "",
          page: "1",
        }
      })
    } else {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: tabKey,
          status: tabKey,
          order_status: "",
          supplier_id: "",
          vendor_id: "",
          purchase_date_from: dateFilter.date_from
            ? dateFilter.date_from
            : aweekago,
          purchase_date_to: dateFilter.date_to ? dateFilter.date_to : today,
          page: "1",
        }
      })
    }
  }

  const handleFilterChange = (e) => {
    setCurrentPage(1)
    const { name, value } = e.target
    if (name === "supplier_id") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          supplier_id: value,
          page: 1,
        }
      })
    } else {
      if (name === "type") {
        setFilterConfig((prev) => {
          return {
            ...prev,
            [name]: value,
            supplier: "",
            supplier_id: "",
            vendor_id: "",
            page: 1,
          }
        })
        setSelectedSupplier({
          label: "All Suppliers",
          value: "",
        })
      } else {
        setFilterConfig((prev) => {
          return {
            ...prev,
            [name]: value,
            page: 1,
          }
        })
      }
    }
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  async function handlePrintPI() {
    toast.loading("Printing Details", { style: toastStyle() })
    handleClosePrintModal()
    setTimeout(() => {
      toast.dismiss()
      // handleChangeStatus() //function for changing status of multiple po
      Print()
    }, 1000)
  }

  function handleOnCheck(row) {
    setCheckedItems(row.selectedRows)
    var ids = row.selectedRows
      .map((data) => {
        return data.id
      })
      .join(", ")
    var dates = row.selectedRows
      .map((data) => {
        return data.purchase_date
      })
      .join(", ")
    var info = {
      ids: ids,
      dates: dates,
    }
    setCheckedItemsDetails(info)
  }

  function renderTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Item</th>
            <th>Ordered Qty</th>
            <th>Remaining Qty</th>
            <th>Unit</th>
            <th>Receive Unit</th>
            <th>Receive Qty</th>
            <th>No. of Boxes</th>
          </tr>
        </thead>
        <tbody>
          {printItems?.map((item) => {
            return (
              <tr>
                <td>{item.item_name}</td>
                <td>{item.order_qty}</td>
                <td>{item.remaining_qty}</td>
                <td className="text-lowercase">{item.unit}</td>
                <td></td>
                <td></td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  useEffect(() => {
    searchPO(filterConfig)
  }, [filterConfig, currentPage])

  useEffect(() => {
    fetchSuppliers()
  }, [])

  async function handleDeletePO() {
    setIsClicked(true)
    const response = await deletePurchaseOrder(poID.id)
    if (response.response) {
      toast.success("Purchase Order Deleted Successfully!", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      TokenExpiry(response)
      toast.error("Error Deleting Purchase Order", {
        style: toastStyle(),
      })
    }
  }

  /* return modal handler */
  const [showReturnModal, setShowReturnModal] = useState(false)
  const handleShowReturnModal = () => setShowReturnModal(true)
  const handleCloseReturnModal = () => setShowReturnModal(false)

  async function handleReturnPO() {
    const id = poID.id
    setIsClicked(true)
    const response = await changeStatusPurchaseOrder(id, "pending")
    if (response.response !== "purchase not found") {
      toast.success("Purchase Returned to Pending", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      TokenExpiry(response)
      toast.error("Error Returning Purchase to Pending", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    }
  }

  async function handleClosePO() {
    const id = poID.id.split("-")
    setIsClicked(true)

    const response = await changeStatusPurchaseOrder(id, "closed")
    if (response.response) {
      toast.success("Purchase closed", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      TokenExpiry(response)
      toast.error("Error closing purchase order", {
        style: toastStyle(),
      })
    }
  }

  async function handleApprovePO() {
    var braddex = checkedItems.filter((data) => {
      return data.type === ""
    })

    setIsClicked(true)
    const response = await changeMultipleStatus(braddex, "approve")

    if (response.response) {
      toast.success("Purchase order/s approved successfully", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      // TokenExpiry(response);
      toast.error("Error approving purchase order", {
        style: toastStyle(),
      })
    }
  }

  async function handleDisapprovePO() {
    setIsClicked(true)

    const response = await changeMultipleStatus(checkedItems, "disapproved")

    if (response.response) {
      toast.success("Purchase order/s disapproved successfully", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      // TokenExpiry(response);
      toast.error("Error disapproving purchase order", {
        style: toastStyle(),
      })
    }
  }

  const [suppliers, setSuppliers] = useState([])

  const [supplierList, setSupplierList] = useState([])
  const [selectedSupplier, setSelectedSupplier] = useState({
    label: "All Suppliers",
    value: "",
  })

  useEffect(() => {
    setSupplierList(
      suppliers.map((supplier) => {
        return {
          label: supplier.trade_name,
          value: supplier.id,
          // value: supplier.id + "|" + supplier.type,
        }
      })
    )
    setSupplierList((branches) => {
      var newBranches = [{ label: "All Suppliers", value: "" }, ...branches]
      return newBranches
    })
  }, [suppliers])

  function handleSupplierChange(e) {
    setSelectedSupplier({
      label: e.label,
      value: e.value,
    })
    const toFilter = { target: { name: "supplier_id", value: e.value } }
    handleFilterChange(toFilter)
  }

  async function fetchSuppliers() {
    setSuppliers([])

    const suppliersResponse = await getAllSuppliers()
    if (suppliersResponse.data) {
      suppliersResponse.data.data.map((supplier) => {
        var info = supplier
        info.type = "supplier"
        setSuppliers((prev) => [...prev, info])
      })
    } else {
      TokenExpiry(suppliersResponse)
    }
  }

  async function handleSelectChange(e, suppID, type, row) {
    setPoID({ id: e.target.id, supplier: suppID, name: row.trade_name })
    setPOType(type)
    switch (e.target.value) {
      case "edit-po":
        var info = e.target.id.split("-")
        navigate("/purchaseorders/edit/" + e.target.id + "/" + type)
        break

      case "delete-po":
        handleShowDeleteModal()
        break

      case "return-po":
        handleShowReturnModal()
        break

      case "print-po":
        navigate("/purchaseorders/print/" + e.target.id, {
          state: { type: type, suppID: suppID },
        })
        break

      case "view-po":
        navigate("/purchaseorders/print/" + e.target.id, {
          state: { type: type, suppID: suppID },
        })
        break

      case "review-po":
        if (type === "completed" || type === "incomplete") {
          navigate("/purchaseorders/review/1/" + e.target.id)
        } else {
          navigate(
            "/purchaseorders/review/0/" +
              // info[0].replace(/\s/g, "") +
              // "/" +
              e.target.id
          )
        }
        break

      case "payment-po":
        setBal(numberFormatInt(row.balance))
        handleShowAddPaymentModal()
        break

      case "send-po":
        handleShowSendModal()
        break

      case "close-po":
        handleShowClosePOModal()
        break

      case "email-po":
        navigate("/purchaseorders/print/" + e.target.id, {
          state: { type: type, suppID: suppID },
        })
        break

      case "receive-po":
        navigate("/purchaseinvoices/add/" + e.target.id)
        break

      default:
        break
    }
  }

  /* send modal handler */
  const [showSendModal, setShowSendModal] = useState(false)
  const handleShowSendModal = () => setShowSendModal(true)
  const handleCloseSendModal = () => setShowSendModal(false)

  /* close modal handler */
  const [showClosePOModal, setShowClosePOModal] = useState(false)
  const handleShowClosePOModal = () => setShowClosePOModal(true)
  const handleCloseClosePOModal = () => setShowClosePOModal(false)

  async function handleSendPO() {
    const id = poID.id.split("_")
    setIsClicked(true)
    const response = await changeStatusPurchaseOrder(id[1], "sent")

    if (response.response.response === "purchase status changed successfully") {
      toast.success("Purchase Sent Successfully", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      TokenExpiry(response)
      toast.error("Error Sending Purchase", { style: toastStyle() })
      setTimeout(() => refreshPage(), 1000)
    }
  }

  /* email modal handler */
  const [showEmailModal, setShowEmailModal] = useState(false)
  const handleCloseEmailModal = () => {
    setShowEmailModal(false)
  }

  const [showLoader, setShowLoader] = useState(false)

  function InvoiceBtn(row) {
    return (
      <ButtonGroup vertical>
        <>
          {row.invoice_no?.map((row) => {
            return (
              <button
                type="button"
                className="button-secondary table-button w-100 p-2"
                onClick={() => handleViewInvoice(row.id)}
              >
                {row.invoice_no ? row.invoice_no : row.id}
              </button>
            )
          })}
        </>
      </ButtonGroup>
      // <span
      //   className="me-4 align-middle ps-label blue"
      //   onClick={() => handleViewInvoice(row.invoice_id, row.type)} //or show modal
      // >
      //   {row.invoice}
      // </span>
    )
  }

  function handleViewInvoice(id) {
    navigate("/purchaseinvoices/print/" + id)
  }

  function ViewBtn(row, type) {
    return (
      <button
        type="button"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
        value="view-po"
      >
        View
      </button>
    )
  }

  function EditBtn(row, type) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
        value="edit-po"
      >
        Edit
      </button>
    )
  }

  function ReviewBtn(row, type) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
        value="review-po"
      >
        {type !== "completed" ? "Review" : "View"}
      </button>
    )
  }

  function AddPaymentBtn(row, type) {
    //
    if (row.can_be_paid === "0") {
      return (
        <button
          name="action"
          className="btn btn-sm view-btn-table"
          id={row.id}
          onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
          value="payment-po"
        >
          Add PMT
        </button>
      )
    }
  }

  function ReceivePOBtn(row, type) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
        value="receive-po"
      >
        Receive
      </button>
    )
  }

  function DonePOBtn(row, type) {
    return (
      <div className="d-flex flex-column gap-1 py-1">
        <button
          name="action"
          className="btn btn-sm view-btn-table"
          id={row.id}
          onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
          value="view-po"
        >
          View
        </button>
        <button
          name="action"
          className="btn btn-sm view-btn-table"
          id={row.id}
          onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
          value="receive-po"
        >
          Receive
        </button>
        <button
          name="action"
          className="btn btn-sm view-btn-table"
          id={row.id}
          onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
          value="close-po"
        >
          Close
        </button>
      </div>
    )
  }

  function ReturnBtn(row, type) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
        value="return-po"
      >
        Back-Pnding
      </button>
    )
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row.supplier_id, type, row)}
      >
        <option value="" selected hidden>
          Select
        </option>
        {type === "deleted" ? (
          <>
            <option value="view-po" className="color-options">
              View
            </option>
          </>
        ) : (
          <>
            {type.startsWith("approved") ? (
              <>
                <option value="print-po" className="color-options">
                  {type.includes("printed") ? "Reprint" : "Print"}
                </option>
                <option value="email-po" className="color-options">
                  Email to Supplier
                </option>
              </>
            ) : (
              <>
                {type === "sent" ? (
                  <>
                    <option value="print-po" className="color-options">
                      View
                    </option>
                    <option value="receive-po" className="color-options">
                      Receive
                    </option>
                    {/* <option value="email-po" className="color-yellow">
                      Email to Supplier
                    </option> */}
                  </>
                ) : (
                  <>
                    {type === "disapproved" ? (
                      <>
                        <option value="view-po" className="color-options">
                          View
                        </option>
                        <option value="return-po" className="color-yellow">
                          Back-Pending
                        </option>
                      </>
                    ) : (
                      <>
                        {type === "for approval" ? (
                          <>
                            <option value="review-po" className="color-options">
                              Review for Approval
                            </option>
                          </>
                        ) : (
                          <>
                            {type === "incomplete" ? (
                              <>
                                <option
                                  value="review-po"
                                  className="color-options"
                                >
                                  View
                                </option>
                                <option
                                  value="close-po"
                                  className="color-options"
                                >
                                  Close
                                </option>
                              </>
                            ) : (
                              <>
                                {userType === "admin" && (
                                  <option
                                    value="edit-po"
                                    className="color-options"
                                  >
                                    Edit
                                  </option>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {userType === "admin" &&
              type !== "incomplete" &&
              type !== "sent" &&
              type !== "approved" && (
                <option value="delete-po" className="color-red">
                  Delete
                </option>
              )}
          </>
        )}
      </Form.Select>
    )
  }

  function redirectAddTo() {
    return navigate("/purchaseorders/add")
  }

  function ContractBtn(row) {
    return (
      <ButtonGroup vertical>
        <>
          {row.payments?.map((row) => {
            return (
              <button
                type="button"
                className="button-secondary table-button w-100 p-2"
                onClick={() => handleViewContract(row.id, row.payment_mode)}
              >
                {row.doc_no}
              </button>
            )
          })}
        </>
      </ButtonGroup>
    )
  }
  function handleViewContract(id, payment_mode) {
    // navigate("/purchaseinvoices/print/" + id);
    navigate("/paysuppliers/view/" + id + "/" + payment_mode)
  }
  return (
    <div className="page">
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              PURCHASE ORDER{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="anything"
              placeholder="Search..."
              className="search-bar"
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
            />
          </Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button className="add-btn" onClick={() => redirectAddTo()}>
                Add
              </button>
            </div>
          </Col>
        </Row>

        {accountType !== "warehouse_manager" &&
        accountType !== "warehouse_assistant" ? (
          <>
            <Tabs
              activeKey={filterConfig.tab}
              defaultActiveKey={filterConfig.tab}
              id="PO-tabs"
              onSelect={handleTabSelect}
            >
              <Tab eventKey="pending" title="pending">
                <div className="mb-3" />
                <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                  Filter By:
                </span>
                <Row className="PO-filters flex flex-row mx-2 my-1">
                  <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                    <Select
                      className="dropsearch-filter"
                      classNamePrefix="react-select"
                      placeholder="Select Supplier"
                      styles={selectDropdownStyle}
                      value={selectedSupplier}
                      options={supplierList}
                      onChange={handleSupplierChange}
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_from"
                      placeholderText={"Select date from"}
                      selected={filterConfig.purchase_date_from}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateFrom(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_from: date, page: 1 }
                        })
                      }}
                      fixedHeight
                      className="date-filter me-4 form-control"
                      showYearDropdown
                      dateFormatCalendar="MMMM"
                      dateFormat="MMM dd, yyyy"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_to"
                      placeholderText={"Select date to"}
                      selected={filterConfig.purchase_date_to}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateTo(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_to: date, page: 1 }
                        })
                      }}
                      className="date-filter ps-label-content me-5 form-control"
                      showYearDropdown
                      dateFormatCalendar="MMMM"
                      dateFormat="MMM dd, yyyy"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>
                </Row>
                <div className="mb-2" />

                <TableWithDynamicPagination
                  tableHeaders={[
                    " ",
                    "PO NO.",
                    "PO DATE",
                    "SUPPLIER",
                    "TOTAL",
                    "PREP. BY",
                    "ACTIONS",
                  ]}
                  headerSelector={[
                    "",
                    "id",
                    "purchase_date",
                    "trade_name",
                    "grand_total",
                    "added_by_name",
                  ]}
                  tableData={purchasesManager}
                  ActionBtn={(row) => ActionBtn(row, "pending")}
                  PendingBtn={(row) => EditBtn(row, "pending")}
                  showLoader={showLoader}
                  // used in dynamic pagination
                  totalItems={totalItems}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  handlePageChange={handlePageChange}
                />
                <div className="mb-2" />
              </Tab>
              <Tab eventKey="for_approval" title="for approval">
                <div className="mb-3" />
                <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                  Filter By:
                </span>
                <Row className="PO-filters flex flex-row mx-2 my-1">
                  <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                    <Select
                      className="dropsearch-filter"
                      classNamePrefix="react-select"
                      placeholder="Select Supplier"
                      styles={selectDropdownStyle}
                      value={selectedSupplier}
                      options={supplierList}
                      onChange={handleSupplierChange}
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_from"
                      placeholderText={"Select date from"}
                      selected={filterConfig.purchase_date_from}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateFrom(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_from: date, page: 1 }
                        })
                      }}
                      fixedHeight
                      className="date-filter me-4 form-control"
                      showYearDropdown
                      dateFormat="MMM dd, yyyy"
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>

                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_to"
                      placeholderText={"Select date to"}
                      selected={filterConfig.purchase_date_to}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateTo(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_to: date, page: 1 }
                        })
                      }}
                      className="date-filter ps-label-content me-5 form-control"
                      showYearDropdown
                      dateFormat="MMM dd, yyyy"
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>
                </Row>
                <div className="mb-2" />

                <AdjustmentTableWithDynamicPagination
                  tableHeaders={[
                    "-",
                    "PO NO.",
                    "PO DATE",
                    "SUPPLIER",
                    "TOTAL",
                    "PREP. BY",
                    "ACTIONS",
                  ]}
                  headerSelector={[
                    "-",
                    "id",
                    "purchase_date",
                    "trade_name",
                    "grand_total",
                    "added_by_name",
                  ]}
                  tableData={purchasesManager}
                  ActionBtn={(row) => ActionBtn(row, "for approval")}
                  ViewBtn={(row) => ReviewBtn(row, "for approval")}
                  handleOnCheck={(row) => handleOnCheck(row)}
                  showLoader={showLoader}
                  // used in dynamic pagination
                  totalItems={totalItems}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  handlePageChange={handlePageChange}
                />
                <div className="mb-2" />
              </Tab>
              <Tab eventKey="approved" title="approved">
                <div className="mb-3" />
                <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                  Filter By:
                </span>
                <Row className="PO-filters flex flex-row mx-2 my-1">
                  <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                    <Select
                      className="dropsearch-filter"
                      classNamePrefix="react-select"
                      placeholder="Select Supplier"
                      styles={selectDropdownStyle}
                      value={selectedSupplier}
                      options={supplierList}
                      onChange={handleSupplierChange}
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_from"
                      placeholderText={"Select date from"}
                      selected={filterConfig.purchase_date_from}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateFrom(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_from: date, page: 1 }
                        })
                      }}
                      fixedHeight
                      className="date-filter me-4 form-control"
                      showYearDropdown
                      dateFormat="MMM dd, yyyy"
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_to"
                      placeholderText={"Select date to"}
                      selected={filterConfig.purchase_date_to}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateTo(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_to: date, page: 1 }
                        })
                      }}
                      className="date-filter ps-label-content me-5 form-control"
                      showYearDropdown
                      dateFormat="MMM dd, yyyy"
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>
                </Row>
                <div className="mb-2" />

                <TableWithDynamicPagination
                  tableHeaders={[
                    "PO NO.",
                    "PO DATE",
                    "SUPPLIER",
                    "TOTAL",
                    "PREP. BY",
                    "APPR. BY",
                    "ACTIONS",
                  ]}
                  headerSelector={[
                    "id",
                    "purchase_date",
                    "trade_name",
                    "grand_total",
                    "added_by_name",
                    "approved_by_name",
                  ]}
                  tableData={purchasesManager}
                  ActionBtn={(row) => ActionBtn(row, row.po_status)}
                  showLoader={showLoader}
                  // used in dynamic pagination
                  totalItems={totalItems}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  handlePageChange={handlePageChange}
                />
                <div className="mb-2" />
              </Tab>
              <Tab eventKey="sent" title="sent">
                <div className="mb-3" />
                <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                  Filter By:
                </span>
                <Row className="PO-filters flex flex-row mx-2 my-1">
                  <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                    <Select
                      className="dropsearch-filter"
                      classNamePrefix="react-select"
                      placeholder="Select Supplier"
                      styles={selectDropdownStyle}
                      value={selectedSupplier}
                      options={supplierList}
                      onChange={handleSupplierChange}
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_from"
                      placeholderText={"Select date from"}
                      selected={filterConfig.purchase_date_from}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateFrom(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_from: date, page: 1 }
                        })
                      }}
                      fixedHeight
                      className="date-filter me-4 form-control"
                      showYearDropdown
                      dateFormat="MMM dd, yyyy"
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_to"
                      placeholderText={"Select date to"}
                      selected={filterConfig.purchase_date_to}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateTo(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_to: date, page: 1 }
                        })
                      }}
                      className="date-filter ps-label-content me-5 form-control"
                      showYearDropdown
                      dateFormat="MMM dd, yyyy"
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>
                  {checkedItems.length > 0 && filterConfig.tab === "sent" && (
                    <>
                      <Col xs={12} lg={2} className="mt-2 mt-lg-0">
                        <div className="PO-filters">
                          <button
                            type="button"
                            className="date-filter ps-label-content me-5 form-control"
                            onClick={handleShowPrintModal}
                          >
                            Print
                          </button>
                        </div>
                      </Col>
                    </>
                  )}
                </Row>
                <div className="mb-2" />

                <AdjustmentTableWithDynamicPagination
                  tableHeaders={[
                    "+",
                    " ",
                    "PO NO.",
                    "PO DATE",
                    "SUPPLIER",
                    "TOTAL",
                    // "BALANCE",
                    "PMT STATUS",
                    "PMT REF NO",
                    "PREP. BY",
                    "APPR. BY",
                    "ACTIONS",
                  ]}
                  headerSelector={[
                    "+",
                    "",
                    "id",
                    "purchase_date",
                    "trade_name",
                    "grand_total",
                    // "balance",
                    "payment_status",
                    "pay_ref_no",
                    "added_by_name",
                    "approved_by_name",
                  ]}
                  tableData={purchasesManager}
                  ActionBtn={(row) => ActionBtn(row, "sent")}
                  PendingBtn={(row) => ReceivePOBtn(row, "sent")}
                  newTabBtn={(row) => ContractBtn(row)}
                  PaymentBtn={(row) => AddPaymentBtn(row, "sent")}
                  handleOnCheck={(row) => handleOnCheck(row)}
                  showLoader={showLoader}
                  // used in dynamic pagination
                  totalItems={totalItems}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  handlePageChange={handlePageChange}
                />
                <div className="mb-2" />
              </Tab>
              <Tab eventKey="incomplete" title="incomplete">
                <div className="mb-3" />
                <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                  Filter By:
                </span>
                <Row className="PO-filters flex flex-row mx-2 my-1">
                  <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                    <Select
                      className="dropsearch-filter"
                      classNamePrefix="react-select"
                      placeholder="Select Supplier"
                      styles={selectDropdownStyle}
                      value={selectedSupplier}
                      options={supplierList}
                      onChange={handleSupplierChange}
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_from"
                      placeholderText={"Select date from"}
                      selected={filterConfig.purchase_date_from}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateFrom(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_from: date, page: 1 }
                        })
                      }}
                      fixedHeight
                      className="date-filter me-4 form-control"
                      showYearDropdown
                      dateFormat="MMM dd, yyyy"
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_to"
                      placeholderText={"Select date to"}
                      selected={filterConfig.purchase_date_to}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateTo(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_to: date, page: 1 }
                        })
                      }}
                      className="date-filter ps-label-content me-5 form-control"
                      showYearDropdown
                      dateFormat="MMM dd, yyyy"
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>
                </Row>
                <div className="mb-2" />

                <TableWithDynamicPagination
                  tableHeaders={[
                    "   ",
                    "PO NO.",
                    "INV NO.",
                    "PO DATE",
                    "SUPPLIER",
                    "TOTAL",
                    "PMT STATUS",
                    "PMT REF NO",
                    "PREP. BY",
                    "APPR. BY",
                    "ACTIONS",
                  ]}
                  headerSelector={[
                    "",
                    "id",
                    "invoice",
                    "purchase_date",
                    "trade_name",
                    "grand_total",
                    "payment_status",
                    "pay_ref_no",
                    "added_by_name",
                    "approved_by_name",
                  ]}
                  tableData={purchasesManager}
                  PendingBtn={(row) => DonePOBtn(row, "incomplete")}
                  newTabBtn={(row) => ContractBtn(row)}
                  ActionBtn={(row) => ActionBtn(row, "incomplete")}
                  InvoiceBtn={(row) => InvoiceBtn(row)}
                  showLoader={showLoader}
                  // used in dynamic pagination
                  totalItems={totalItems}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  handlePageChange={handlePageChange}
                />
                <div className="mb-2" />
              </Tab>
              <Tab eventKey="complete" title="completed">
                <div className="mb-3" />
                <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                  Filter By:
                </span>
                <Row className="PO-filters flex flex-row mx-2 my-1">
                  <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                    <Select
                      className="dropsearch-filter"
                      classNamePrefix="react-select"
                      placeholder="Select Supplier"
                      styles={selectDropdownStyle}
                      value={selectedSupplier}
                      options={supplierList}
                      onChange={handleSupplierChange}
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_from"
                      placeholderText={"Select date from"}
                      selected={filterConfig.purchase_date_from}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateFrom(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_from: date, page: 1 }
                        })
                      }}
                      fixedHeight
                      className="date-filter me-4 form-control"
                      showYearDropdown
                      dateFormat="MMM dd, yyyy"
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_to"
                      placeholderText={"Select date to"}
                      selected={filterConfig.purchase_date_to}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateTo(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_to: date, page: 1 }
                        })
                      }}
                      className="date-filter ps-label-content me-5 form-control"
                      showYearDropdown
                      dateFormat="MMM dd, yyyy"
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>
                </Row>
                <div className="mb-2" />

                <TableWithDynamicPagination
                  tableHeaders={[
                    " ",
                    "PO NO.",
                    "INV NO.",
                    "PO DATE",
                    "COMPLETED ON",
                    "SUPPLIER",
                    "TOTAL",
                    // "BALANCE",
                    "PMT STATUS",
                    "PMT REF NO",
                    "PREP. BY",
                    "APPR. BY",
                  ]}
                  headerSelector={[
                    "",
                    "id",
                    "invoice",
                    "purchase_date",
                    "completed_on",
                    "trade_name",
                    "grand_total",
                    // "balance",
                    "payment_status",
                    "pay_ref_no",
                    "added_by_name",
                    "approved_by_name",
                  ]}
                  tableData={purchasesManager}
                  PendingBtn={(row) => ReviewBtn(row, "completed")}
                  newTabBtn={(row) => ContractBtn(row)}
                  InvoiceBtn={(row) => InvoiceBtn(row)}
                  showLoader={showLoader}
                  // used in dynamic pagination
                  totalItems={totalItems}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  handlePageChange={handlePageChange}
                />
                <div className="mb-2" />
              </Tab>
              <Tab eventKey="" title="All">
                <div className="mb-3" />
                <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                  Filter By:
                </span>
                <Row className="PO-filters flex flex-row mx-2 my-1">
                  <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                    <Select
                      className="dropsearch-filter"
                      classNamePrefix="react-select"
                      placeholder="Select Supplier"
                      styles={selectDropdownStyle}
                      value={selectedSupplier}
                      options={supplierList}
                      onChange={handleSupplierChange}
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_from"
                      placeholderText={"Select date from"}
                      selected={filterConfig.purchase_date_from}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateFrom(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_from: date, page: 1 }
                        })
                      }}
                      fixedHeight
                      className="date-filter me-4 form-control"
                      showYearDropdown
                      dateFormat="MMM dd, yyyy"
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>
                  <Col xs={6} lg={2}>
                    <DatePicker
                      autoComplete="off"
                      name="purchase_date_to"
                      placeholderText={"Select date to"}
                      selected={filterConfig.purchase_date_to}
                      onChange={(date) => {
                        setCurrentPage(1)
                        setDateTo(moment(date).format("YYYY-MM-DD"))
                        setFilterConfig((prev) => {
                          return { ...prev, purchase_date_to: date, page: 1 }
                        })
                      }}
                      className="date-filter ps-label-content me-5 form-control"
                      showYearDropdown
                      dateFormat="MMM dd, yyyy"
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                    />
                  </Col>
                </Row>
                <div className="mb-2" />

                <TableWithDynamicPagination
                  tableHeaders={[
                    " ",
                    "PO NO.",
                    "INV NO.",
                    "PO DATE",
                    "COMPLETED ON",
                    "SUPPLIER",
                    "TOTAL",
                    "PMT STATUS",
                    "PMT REF NO",
                    "PREP. BY",
                    "APPR. BY",
                  ]}
                  headerSelector={[
                    "",
                    "id",
                    "invoice",
                    "purchase_date",
                    "completed_on",
                    "trade_name",
                    "grand_total",
                    "payment_status",
                    "pay_ref_no",
                    "added_by_name",
                    "approved_by_name",
                  ]}
                  tableData={purchasesManager}
                  PendingBtn={(row) => ViewBtn(row, row.po_status)}
                  newTabBtn={(row) => ContractBtn(row)}
                  InvoiceBtn={(row) => InvoiceBtn(row)}
                  showLoader={showLoader}
                  // used in dynamic pagination
                  totalItems={totalItems}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  handlePageChange={handlePageChange}
                />
                <div className="mb-2" />
              </Tab>
            </Tabs>
          </>
        ) : (
          <>
            <Tabs
              activeKey={filterConfig.tab}
              defaultActiveKey={filterConfig.tab}
              id="PO-tabs"
              onSelect={handleTabSelect}
            >
              <Tab eventKey="sent" title="sent">
                <div className="my-2 px-4 PO-filters d-flex">
                  <span className="me-4 align-middle mt-2">Filter By:</span>
                  <Select
                    className="dropsearch-filter px-0 py-0 me-2"
                    classNamePrefix="react-select"
                    placeholder="Select Supplier"
                    styles={selectDropdownStyle}
                    value={selectedSupplier}
                    options={supplierList}
                    onChange={handleSupplierChange}
                  />

                  <span className="me-3 align-middle mt-2">Date From:</span>
                  <DatePicker
                    autoComplete="off"
                    name="purchase_date_from"
                    placeholderText={"Select date"}
                    selected={filterConfig.purchase_date_from}
                    onChange={(date) => {
                      setCurrentPage(1)
                      setDateFrom(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, purchase_date_from: date, page: 1 }
                      })
                    }}
                    fixedHeight
                    className="PI-date-btn me-3 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />

                  <span className="me-3 align-middle mt-2">To:</span>
                  <DatePicker
                    autoComplete="off"
                    name="purchase_date_to"
                    placeholderText={"Select date"}
                    selected={filterConfig.purchase_date_to}
                    onChange={(date) => {
                      setCurrentPage(1)
                      setDateTo(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, purchase_date_to: date, page: 1 }
                      })
                    }}
                    className="PI-date-btn me-3 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />
                  <span className="me-5 ms5"></span>
                  <span className="me-5 ms5"></span>
                  <span className="me-5 ms5"></span>
                  <span className="me-5 ms5"></span>
                  {checkedItems.length > 0 && filterConfig.tab === "sent" && (
                    <button
                      type="button"
                      className="ms-5 button-primary float-right position-right"
                      onClick={handleShowPrintModal}
                    >
                      Print
                    </button>
                  )}
                </div>

                <AdjustmentTable
                  tableHeaders={[
                    "+",
                    " ",
                    "PO NO.",
                    "PO DATE",
                    "SUPPLIER",
                    "TOTAL",
                    // "BALANCE",
                    "PMT STATUS",
                    "PMT REF NO",
                    "PREP. BY",
                    "APPR. BY",
                    "ACTIONS",
                  ]}
                  headerSelector={[
                    "+",
                    "",
                    "id",
                    "purchase_date",
                    "trade_name",
                    "grand_total",
                    // "balance",
                    "payment_status",
                    "pay_ref_no",
                    "added_by_name",
                    "approved_by_name",
                  ]}
                  tableData={purchasesManager}
                  ActionBtn={(row) => ActionBtn(row, "sent")}
                  PendingBtn={(row) => ReceivePOBtn(row, "sent")}
                  newTabBtn={(row) => ContractBtn(row)}
                  PaymentBtn={(row) => AddPaymentBtn(row, "sent")}
                  handleOnCheck={(row) => handleOnCheck(row)}
                  showLoader={showLoader}
                />
                <div className="mb-2" />
              </Tab>
              <Tab eventKey="incomplete" title="incomplete">
                <div className="my-2 px-4 PO-filters d-flex">
                  <span className="me-4 align-middle mt-2">Filter By:</span>
                  <Select
                    className="dropsearch-filter px-0 py-0 me-2"
                    classNamePrefix="react-select"
                    placeholder="Select Supplier"
                    styles={selectDropdownStyle}
                    value={selectedSupplier}
                    options={supplierList}
                    onChange={handleSupplierChange}
                  />
                  <span className="me-3 align-middle mt-2">Date From:</span>
                  <DatePicker
                    autoComplete="off"
                    name="purchase_date_from"
                    placeholderText={"Select date"}
                    selected={filterConfig.purchase_date_from}
                    onChange={(date) => {
                      setCurrentPage(1)
                      setDateFrom(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, purchase_date_from: date, page: 1 }
                      })
                    }}
                    fixedHeight
                    className="PI-date-btn me-3 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />

                  <span className="me-3 align-middle mt-2">To:</span>
                  <DatePicker
                    autoComplete="off"
                    name="purchase_date_to"
                    placeholderText={"Select date"}
                    selected={filterConfig.purchase_date_to}
                    onChange={(date) => {
                      setCurrentPage(1)
                      setDateTo(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, purchase_date_to: date, page: 1 }
                      })
                    }}
                    className="PI-date-btn me-3 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />
                </div>

                <TableTemp
                  tableHeaders={[
                    "   ",
                    "PO NO.",
                    "PO DATE",
                    "SUPPLIER",
                    "TOTAL",
                    // "BALANCE",
                    "PMT STATUS",
                    "PMT REF NO",
                    "PREP. BY",
                    "APPR. BY",
                    "ACTIONS",
                  ]}
                  headerSelector={[
                    "",
                    "id",
                    "purchase_date",
                    "trade_name",
                    "grand_total",
                    // "balance",
                    "payment_status",
                    "pay_ref_no",
                    "added_by_name",
                    "approved_by_name",
                  ]}
                  tableData={purchasesManager}
                  PendingBtn={(row) => DonePOBtn(row, "incomplete")}
                  newTabBtn={(row) => ContractBtn(row)}
                  ActionBtn={(row) => ActionBtn(row, "incomplete")}
                  showLoader={showLoader}
                />
                <div className="mb-2" />
              </Tab>
              <Tab eventKey="complete" title="completed">
                <div className="my-2 px-4 PO-filters d-flex">
                  <span className="me-4 align-middle mt-2">Filter By:</span>
                  <Select
                    className="dropsearch-filter px-0 py-0 me-2"
                    classNamePrefix="react-select"
                    placeholder="Select Supplier"
                    styles={selectDropdownStyle}
                    value={selectedSupplier}
                    options={supplierList}
                    onChange={handleSupplierChange}
                  />

                  <span className="me-3 align-middle mt-2">Date From:</span>
                  <DatePicker
                    autoComplete="off"
                    name="purchase_date_from"
                    placeholderText={"Select date"}
                    selected={filterConfig.purchase_date_from}
                    onChange={(date) => {
                      setCurrentPage(1)
                      setDateFrom(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, purchase_date_from: date, page: 1 }
                      })
                    }}
                    fixedHeight
                    className="PI-date-btn me-3 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />

                  <span className="me-3 align-middle mt-2">To:</span>
                  <DatePicker
                    autoComplete="off"
                    name="purchase_date_to"
                    placeholderText={"Select date"}
                    selected={filterConfig.purchase_date_to}
                    onChange={(date) => {
                      setCurrentPage(1)
                      setDateTo(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, purchase_date_to: date, page: 1 }
                      })
                    }}
                    className="PI-date-btn me-3 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />
                </div>

                <TableTemp
                  tableHeaders={[
                    " ",
                    "PO NO.",
                    "INV NO.",
                    "PO DATE",
                    "COMPLETED ON",
                    "SUPPLIER",
                    "TOTAL",
                    // "BALANCE",
                    "PMT STATUS",
                    "PMT REF NO",
                    "PREP. BY",
                    "APPR. BY",
                  ]}
                  headerSelector={[
                    "",
                    "id",
                    "invoice",
                    "purchase_date",
                    "completed_on",
                    "trade_name",
                    "grand_total",
                    // "balance",
                    "payment_status",
                    "pay_ref_no",
                    "added_by_name",
                    "approved_by_name",
                  ]}
                  tableData={purchasesManager}
                  PendingBtn={(row) => ViewBtn(row, row.po_status)}
                  newTabBtn={(row) => ContractBtn(row)}
                  InvoiceBtn={(row) => InvoiceBtn(row)}
                  showLoader={showLoader}
                />
                <div className="mb-2" />
              </Tab>
            </Tabs>
          </>
        )}
        {filterConfig.tab === "for_approval" && getType() === "admin" ? (
          <>
            <div className="d-flex justify-content-end pt-3 mb-3 mr-3">
              <button
                type="button"
                className="button-primary mr-3 "
                onClick={() => handleShowApproveModal()}
              >
                Approve
              </button>
              <button
                type="button"
                className="button-secondary"
                onClick={() => handleShowDisapproveModal()}
              >
                Disapprove
              </button>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
      <div
        className="display-none print-container px-3 py-2 "
        id="printablediv"
      >
        {/* {
          checkedItems?.map((data, index) => {
              return (
                  <> */}
        <div className="print-item">
          <div className="text-end print-header">
            <span>{Moment().format("MMM DD, YYYY")}</span>
          </div>
          <div className="print-top d-flex justify-content-center py-1">
            <img src={cleanLogo} className="print-logo" alt="" />
          </div>
          <div className="print-top">
            <h5 className="print-shop-header d-flex justify-content-center">
              497 D Molave Extension, Lahug, Cebu City
            </h5>
            {/* <h5 className="print-shop-header d-flex justify-content-center">San Roque, Cebu City</h5> */}
            <h5 className="print-shop-header d-flex justify-content-center">
              RECEIVING REPORT
            </h5>
          </div>

          {/* content */}
          <div className="print-body mt-5">
            <Row>
              <Col xs={7}>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Supplier:
                  </Col>
                  <Col xs={6} className="print-data">
                    {selectedSupplier.label}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    PO NO.:
                  </Col>
                  <Col xs={6} className="print-data">
                    {checkedItemsDetails.ids}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Purchase Date:
                  </Col>
                  <Col xs={6} className="print-data">
                    {checkedItemsDetails.dates}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Receive Date:
                  </Col>
                  <Col xs={6} className="print-data align-items-start">
                    {Moment().format("MMM DD, YYYY")}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Forwarder:
                  </Col>
                </div>
              </Col>

              <Col xs={5}>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Invoice No.:
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    DR NO.:
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-label">
                    Waybill No.:
                  </Col>
                </div>
              </Col>
            </Row>
            <div className="d-flex mt-5 mb-2 justify-content-evenly">
              {/* table */}
              <div className="print-table mt-3 mx-2">{renderTable()}</div>
            </div>

            <div className="print-signatures">
              <div className="d-flex align-items-center justify-content-end flex-column">
                <span className="text-center text-uppercase nc-modal-custom-text">
                  {/* {data.added_by_name} */}
                </span>
              </div>
              <div className="mt-5 d-flex align-items-center justify-content-center flex-column">
                {/* <img src={signature} className="print-logo" alt=""/> */}
                <span className="text-center text-uppercase nc-modal-custom-text">
                  {/* APPROVERS NAME */}
                </span>
              </div>
            </div>
            <div className="print-signatories pb-4 mb-4">
              <span>Prepared by</span>
              <span>Approved by</span>
            </div>
          </div>
        </div>
        {/* </>
              )
          })
        } */}
      </div>

      {/* modals */}
      <DeleteModal
        show={showDeleteModal}
        onHide={() => handleCloseDeleteModal()}
        text="purchase order"
        onDelete={() => handleDeletePO()}
        isClicked={isClicked}
      />
      <POModal
        show={showReturnModal}
        hide={handleCloseReturnModal}
        type="return"
        handler={handleReturnPO}
        isClicked={isClicked}
      />
      <POModal
        show={showSendModal}
        hide={handleCloseSendModal}
        type="send"
        handler={handleSendPO}
        isClicked={isClicked}
      />
      <POModal
        show={showClosePOModal}
        hide={handleCloseClosePOModal}
        type="close"
        handler={handleClosePO}
        isClicked={isClicked}
      />
      <EmailPurchaseOrder
        show={showEmailModal}
        hide={handleCloseEmailModal}
        po_id={poID.id}
        supplier_id={poID.supplier}
        type={POtype}
      />
      <PoPaymentModal
        id={poID.id}
        show={showAddPaymentModal}
        onHide={handleCloseAddPaymentModal}
        balance={bal}
        payee={poID.name}
      />
      <POModal
        show={showApproveModal}
        hide={handleCloseApproveModal}
        type="approve"
        handler={handleApprovePO}
        isClicked={isClicked}
      />
      <POModal
        show={showDisapproveModal}
        hide={handleCloseDisapproveModal}
        type="disapprove"
        handler={handleDisapprovePO}
        isClicked={isClicked}
      />
      <POModal
        show={showPrintModal}
        hide={handleClosePrintModal}
        type="print"
        handler={mergePoItems}
        isClicked={isClicked}
      />
      <Footer />
    </div>
  )
}
